var cilResizeBoth = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M404.687,212.686l-50.51,50.51L248.805,157.823l50.841-50.843L272.666,80H80V272l27.313,27.314,50.982-50.981L263.667,353.706l-51.313,51.313L239.333,432H432V240ZM400,400H262.627l46.3-46.294L158.295,203.078,112,249.373V112H249.373L203.55,157.823,354.177,308.451,400,262.627Z' class='ci-primary'/>"];

export { cilResizeBoth };

